import React from 'react'
import { Tooltip } from 'antd';
import LanguageTranslator from '../locals/LanguageTranslator';

const GenericStatusComponent = (props) => {

    const { status, onClick, className = "", size = 'medium', statusWrapperClassName = "" } = props;

    const styleName = {
        "APPROVED": "label-success bg-[#03B675] text-white py-0.5 px-[5px] rounded-[3px] font-semibold",
        "RECEIVED": "label-success bg-[#03B675] text-white py-0.5 px-[5px] rounded-[3px] font-semibold",
        "PENDING": "label-pending bg-[#FE9D0B] text-white py-0.5 px-[5px] rounded-[3px] font-semibold",
        "ACCEPTED": "label-success !bg-[#ECB80B] text-white py-0.5 px-[5px] rounded-[3px] font-semibold",
        "FAILED": "label-failed bg-danger text-white py-0.5 px-[5px] rounded-[3px] font-semibold",
        "OPEN": "label-failed bg-danger text-white py-0.5 px-[5px] rounded-[3px] font-semibold",
        "REJECTED": "label-failed bg-danger text-white py-0.5 px-[5px] rounded-[3px] font-semibold",
        "SUCCEEDED": "label-success",
        "ACTIVE": "label-success",
        "INACTIVE": "label-failed",
        "HOLD": "label-pending",
        "PENDING_QC": "label-pending",
        "PASS": "label-success",
        "COMPLETED": "label-success",
        "ERROR": "label-failed",
        "SUCCESS": "label-success",
        "PENDING_QC_CONFIRM": "label-success",
        "SHIPMENT_REQUESTED": "label-pending",
        "IN PROGRESS": "label-pending",
        "RESOLVED": "label-success",
        "SHIPMENT_INVOICE_REQUESTED": "label-pending",
        "PENDING_QC": "label-pending",
        "SHIPMENT_SHIPPED": "label-pending",
        "SHIPMENT_CANCELLED": "label-failed",
        "SHIPMENT_INTRANSIT_CANCELLED": "label-failed",
        "SHIPMENT_INSPECTION_CANCELLED": "label-failed",
        "SHIPMENT_DELIVERED": "label-success",
        "SHIPMENT_CONFIRMED": "label-success",
        "CONFIRMED": "label-success",
        "LOGGED IN": "mb-0 text-xs !font-semibold px-[5px] py-0.5 rounded-[3px] bg-[#5d5fef] !text-white uppercase",
        "FULLY INVOICED": "label-success bg-[#03B675] text-white py-0.5 px-[5px] rounded-[3px] font-semibold",
        "PARTIAL INVOICED": "label-pending bg-[#FE9D0B] text-white py-0.5 px-[5px] rounded-[3px] font-semibold"
    }

    const getFontSize = {
        small: 'small-size-status',
        medium: ''
    }

    return (
        status ?
            <div className={statusWrapperClassName} data-interactive="true" onClick={() => onClick && props.onClick(status)}>
                <Tooltip
                    overlayInnerStyle={{
                        maxHeight: '200px',
                        overflowY: 'auto',
                        backgroundColor: 'white',
                        color: 'black',
                        fontSize: '12px'
                    }}
                    overlayClassName="!p-[0]"
                    title={status?.toString().length >= 23 ? status : null}
                    arrow={true}
                >
                    <LanguageTranslator tag='label' className={`generic-status text-xs text-[#111D31] ${styleName?.[status?.toUpperCase()] || "label-default bg-[#67768E] text-white py-0.5 px-[5px] rounded-[3px] font-semibold"} ${getFontSize[size]} ${className}`}>{status?.toUpperCase()}</LanguageTranslator>
                </Tooltip>
            </div> : null
    )
}

export default GenericStatusComponent